import { memo } from 'react'
import { Stack, Subheader3, Switch } from '@collaborate-health/uikit'
import { useSelector } from '@tabeeb/store'

import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getSelectedTenant, getSourceReviewsByType } from '@tabeeb/modules/sessionsPage/selectors/contentSharings'

interface ActiveReviewsSwitchProps {
  isUpdateActiveReview: boolean
  contentSharingType: ContentSharingModelType
  toggleUpdateActiveReview: (value: boolean) => void
}

const ActiveReviewsSwitch: React.FC<ActiveReviewsSwitchProps> = ({
  isUpdateActiveReview,
  contentSharingType,
  toggleUpdateActiveReview,
}) => {
  const activeReviews = useSelector((state) => getSourceReviewsByType(state, { contentSharingType }))
  const selectedTenant = useSelector((state) => getSelectedTenant(state, { contentSharingType }))

  if (
    contentSharingType !== ContentSharingModelType.MergeForReview ||
    !activeReviews?.length ||
    selectedTenant?.IsPredefined
  ) {
    return null
  }

  return (
    <Stack direction='row' alignItems='center' spacing={1} mb={2}>
      <Subheader3>Update Active Review</Subheader3>
      <Switch checked={isUpdateActiveReview} onClick={() => toggleUpdateActiveReview(!isUpdateActiveReview)} />
    </Stack>
  )
}

export default memo(ActiveReviewsSwitch)

